module.exports = __webpack_public_path__ + "static/media/cameraIconDark.3fbb8f55.png";